import React from 'react';
import { ITableDataSource } from 'models/table';
import { ILegalEntityAddress } from 'models/legalEntity';
import { IParsedDictionary } from 'helpers/dictionary';

export const mapLEAddressToDataSource = (
  items: ILegalEntityAddress[],
  region: IParsedDictionary,
  country: IParsedDictionary,
  type: IParsedDictionary,
  legalEntityId: string,
): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    typeUniqueId:
      item.typeUniqueId && type?.[item.typeUniqueId] ? type[item.typeUniqueId] : '',
    line1: `${item.line1} ${item.line2}`,
    city: item.city,
    postalCode: item.postalCode,
    regionUniqueId:
      item.regionUniqueId && region?.[item.regionUniqueId] ? region[item.regionUniqueId] : '',
    countryUniqueId: item.countryUniqueId,
    country:
      item.countryUniqueId && country?.[item.countryUniqueId]
        ? country[item.countryUniqueId]
        : '',
    gps: `${item.latitude}, ${item.longitude}`,
    latitude: item.latitude,
    longitude: item.longitude,
    isDefault: item.isDefault,
    storage: item.storage,
    legalEntityId,
  }));
